import { render, staticRenderFns } from "./SopPanne.vue?vue&type=template&id=92c8d2c6"
import script from "./SopPanne.vue?vue&type=script&lang=js"
export * from "./SopPanne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports